import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ViewApplication from "../components/view/viewApplication/ViewApplication";

const ApplicationView: React.FC = () => {
  const { applicationId } = useParams();
  const navigate = useNavigate();
  const [applicationData, setApplicationData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchApplication = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/applications/${applicationId}`
        );
        if (res.data.success) {
          console.log(res?.data?.data, "appdata")
          setApplicationData(res?.data.data);
        } else {
          setError(res.data.message || "Application not found");
        }
      } catch (err: any) {
        setError(err.message || "Error fetching application");
      } finally {
        setLoading(false);
      }
    };
    fetchApplication();
  }, [applicationId]);

  if (loading) return <div>Loading application...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
    <ViewApplication
      candidate={applicationData}
      job={applicationData.job}
      onBack={() => navigate("/applications")}
    />
  );
};

export default ApplicationView;
